<template>
    <div class="details_body">
        <ul class="details_tab">
            <li @click="num = 0" :class="{active: num == 0}"><common-data name="appShortName_19"/>介绍</li>
            <li @click="num = 1" :class="{active: num == 1}">功能介绍</li>
            <li @click="num = 2" :class="{active: num == 2}">购买须知</li>
            <!-- <li @click="num = 3" :class="{active: num == 3}">服务介绍</li> -->
        </ul>
        <div class="details_gn" v-show="num == 0">
            <p class="intent">
                文华财经旗下的股票软件，面向机构和专业投资者。
            </p>
            <p class="intent">
                支持构建量化多头、市场中性等策略，提供了包括编写因子、构建策略、生成策略分析报告、策略优化等功能，是一个集成式、全流程的量化选股工具软件。
            </p>
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
        
        
        <div class="details_gn" v-show="num == 1">
            <p class="detail_title">10E基础版</p>
            <p>1.开源因子库：提供量价指标、财务指标、市场估值、持股结构、盈利预测、事件驱动等十几个大类556个Python开源因子；<br>
                2.因子批量分析：支持因子批量分析和列表式因子表现，为因子选择提供辅助决策参考；<br>
                3.可视化、向导式策略构建平台：集成化的策略开发平台，无需代码编写即可构建多因子量化策略；<br>
                4.自建因子：支持个性化自建因子编写，提供日K线/技术指标数据、股票/可转债数据、期货数据、宏观数据；<br>
                5.策略优化工具：支持组合优化、择时优化等策略优化工具。
                </p>
            <!-- <p class="tent">* 仅限使用WT10软件登录</p> -->
            <p class="tent">* 本服务中必须提供的数据及信息仅限用户另外付费选配的范围；服务期内我司有权对其他数据及信息进行增、减等调整。</p>
            <a target="_blank" href="https://wt10.wenhua.com.cn/index.html?aspxerrorpath=/#/buy">>>> 查看10E基础版更多功能</a>
            <!-- <br>
            <br>
            <p class="detail_title">量化投研</p>
            <p class="tent">量化编写平台：python语言平台，配合文华数据库，编写自由，数据丰富，云计算技术保证运算速度，提高研发效率。</p>
            <p class="tent">文华精选因子库：包含了基本面、市场交易和情绪3个大类14个子类的400多个精选因子。覆盖了当前量化领域的常见因子并持续更新。</p>
            <p class="tent">多因子策略：实现因子库和量化投资方法的融合，提供高效灵活的图表化多因子量化投研、组合优化管理和归因分析。</p> -->
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
        <div class="details_gn" v-show="num == 2">
            <p class="tent">1.付费成功后如无功能问题恕不退不换。</p>
            <p class="tent">2.购买前请先下载<a href="https://wt10.wenhua.com.cn/index.html?aspxerrorpath=/#/home" target="_blank"><common-data name="appShortName_19"/></a>体验版了解软件基础功能。</p>
            <p class="tent" style='padding-left:12px;text-indent:-12px;'>
                3.使用<common-data name="appShortName_19"/>的电脑配置要求：<br />
                · X86架构的CPU，4核及以上配置；<br />
                · win7/win2008的64位操作系统，4G内存；<br />
                · win10/win8的64位操作系统，8G内存；
            </p>
            <p class="tent">4.推荐南方地区使用电信网络，北方地区使用联通网络，其它网络使用效果不佳。</p>
            
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                num: 2
            }
        },
    }
</script>
<style scoped>
@import url('./doc.css');
.details_gn{
    min-height: 255px;
}
.details_gn p.tent {
    
}
</style>